import { useTranslation } from 'react-i18next';

import './history-moves.scss';

interface IRoundCounterProps {
  currentRound: number;
}

export const RoundCounter = ({ currentRound }: IRoundCounterProps) => {
  const { t } = useTranslation();
  return (
    <div className="w-full min-w-40 sm:h-11 lg:mt-[18px] lg:h-[76px]">
      <div className="flex w-full flex-col items-center rounded-lg text-md font-semibold leading-9 text-blue-text sm:text-3xl lg:rounded-2xl lg:border-[1.3px] lg:border-border lg:bg-[#01001D4D] lg:text-[28px]">
        <div className="flex h-5 w-full max-w-[385px] items-center justify-center gap-2 rounded-lg border-[1.3px] border-border bg-[#01001D4D] px-4 sm:h-11 sm:px-[39px] lg:h-[76px] lg:border-0 lg:bg-transparent lg:p-5 lg:px-9">
          {t('common.round')} {currentRound}
        </div>
      </div>
    </div>
  );
};
